import { render } from "./HeroiconsOutlineCalculator.vue?vue&type=template&id=de188c66"
const script = {}

import exportComponent from "/home/malezha/zfort/digitalfax/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCalculator.vue"]])

export default __exports__